import { Component, Input, OnInit, Output, EventEmitter, TemplateRef, ViewChild } from '@angular/core';
import { Identity } from '../../identity.model';
import { User } from 'src/app/identity/user.model'
import { IdentityService } from '../../identity.service';
import { LogService } from 'src/app/shared/log.service';

@Component({
  selector: 'app-user-identity',
  templateUrl: './user-identity.component.html',
  styleUrls: ['./user-identity.component.sass']
})
export class UserIdentityComponent implements OnInit {

  @Input() user!: User;
  @Input() identity!: Identity;
  @Output() chooseActionView: EventEmitter<string> = new EventEmitter<string>();
  @ViewChild('actionIdentity', { static: true }) actionIdentity: TemplateRef<any>;
  @ViewChild('actionUserCredentials', { static: true }) actionUserCredentials: TemplateRef<any>;
  @ViewChild('actionActive', { static: true }) actionActive: TemplateRef<any>;
  @ViewChild('actionSuspend', { static: true }) actionSuspend: TemplateRef<any>;
  @ViewChild('actionResume', { static: true }) actionResume: TemplateRef<any>;
  @ViewChild('actionRevoke', { static: true }) actionRevoke: TemplateRef<any>;
  @ViewChild('actionLogs', { static: true }) actionLogs: TemplateRef<any>;

  constructor(private identityService: IdentityService, private logger: LogService) { }

  ngOnInit(): void {
    this.logger.log("IDENTITA' : ", this.identity.status)
  }

  chooseAction(action: string, event: Event) {
    this.logger.log(action)
    this.chooseActionView.emit(action);
    this.identityService.setCurrentIdentity(this.identity)
    event.stopPropagation();
  }

  getActions(): TemplateRef<any>[] {
    switch (this.identity.status) {
      case 'CREATED':
        return [];
        break;
      case 'APPROVED':
        return [];
        break;
      case 'ISSUING':
        return [];
        break;
      case 'ISSUED':
        return [this.actionIdentity, this.actionUserCredentials, this.actionSuspend, this.actionRevoke, this.actionLogs];
        break;
      case 'HOLD':
        return [this.actionIdentity, this.actionUserCredentials, this.actionResume, this.actionLogs];
        break;
      case 'REVOKED':
        return [this.actionIdentity, this.actionUserCredentials, this.actionLogs];
        break;
      case 'EXPIRED':
        return [this.actionIdentity, this.actionUserCredentials, this.actionLogs];
        break;
      default:
        return [this.actionIdentity, this.actionUserCredentials, this.actionLogs];
        break;
    }
  }
}
